import "../css/style.scss"

import SiteHeader from "./modules/SiteHeader"
import Veranstaltungen from "./modules/Veranstaltungen"
import Accordion from "./modules/Accordion"

new SiteHeader()
new Veranstaltungen()
new Accordion()
